var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlueFilterIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 17,
    viewBox: "0 0 12 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 1L7.5 8.5",
    stroke: "#003DA5",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.563265 1.33257C0.527548 1.50448 0.552196 1.6919 0.655152 1.86312L4.14093 7.66012C4.21039 7.77563 4.24708 7.90787 4.24708 8.04265V13.0391C4.24708 13.1863 4.29082 13.3301 4.37273 13.4523L6.58324 16.7511C6.78742 17.0558 7.26273 16.9113 7.26273 16.5445V10.5742L0.563265 1.33257ZM7.90938 6.35488L11.3427 1.93604C11.7216 1.44839 11.3741 0.738281 10.7565 0.738281H3.8378L7.90938 6.35488Z",
    fill: "#003DA5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueFilterIcon);
export default __webpack_public_path__ + "static/media/BlueFilterIcon.a6843b518506da47f81f4dbc0f3ca48a.svg";
export { ForwardRef as ReactComponent };